import { GRID_COLS, GRID_ROWS, TILE_PX } from '@pieskowo/shared';

export type GridConfig = {
  cols?: number;
  rows?: number;
  tilePx?: number;
};

export class GridBoard {
  readonly cols: number;
  readonly rows: number;
  readonly tilePx: number;

  constructor(cfg: GridConfig = {}) {
    this.cols = cfg.cols ?? GRID_COLS;
    this.rows = cfg.rows ?? GRID_ROWS;
    this.tilePx = cfg.tilePx ?? TILE_PX;
  }

  worldToTile(x: number, y: number): { tx: number; ty: number } {
    return {
      tx: Math.floor(x / this.tilePx),
      ty: Math.floor(y / this.tilePx),
    };
  }

  tileToWorld(tx: number, ty: number): { x: number; y: number } {
    return {
      x: tx * this.tilePx + this.tilePx / 2,
      y: ty * this.tilePx + this.tilePx / 2,
    };
  }

  inBounds(tx: number, ty: number): boolean {
    return tx >= 0 && ty >= 0 && tx < this.cols && ty < this.rows;
  }
}
